import { Flex } from '@mantine/core';
import { getStatusStat } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageInvestments/utils/investment.helper.ts';
import { StatusTooltipCount } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageInvestments/components/StatusTooltipCount.tsx';
import type { AllowedStatuses } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageInvestments/components/types.ts';

interface Props {
	orderedStatuses: Array<AllowedStatuses>;
	countsByStatus: Record<AllowedStatuses, number>;
	isKyc?: boolean;
}

export const FooterStatByStatus = ({ orderedStatuses, countsByStatus, isKyc }: Props) => {
	return (
		<Flex gap="0.5rem" wrap="wrap" align="center" h="100%">
			{getStatusStat(orderedStatuses, countsByStatus).map(({ status, count }) => (
				<StatusTooltipCount
					key={status}
					status={status}
					overrideCount={count}
					items={[]}
					isKyc={isKyc}
				/>
			))}
		</Flex>
	);
};
